import axios from 'axios'

const MoskitWrapper = {
  requestToMoskit: (apikey, baseUrl, timeout = 0, nextPageToken) => {
    return new Promise((resolve, reject) => {
      let url = baseUrl
      let config = {
        headers: {
          'apikey': apikey,
          'Content-Type': 'application/json'
        }
      }
      if (nextPageToken) url += `&nextPageToken=${nextPageToken}`
      setTimeout(_ => {
        return axios.get(url, config).then(async (response) => {
          let result = response.data
          const headers = response.headers
          if (headers.hasOwnProperty('x-moskit-listing-next-page-token')) {
            return MoskitWrapper.requestToMoskit(apikey, baseUrl, 500, headers['x-moskit-listing-next-page-token'])
              .then((recursiveResult) => {
                return resolve(result.concat(recursiveResult).flat())
              })
          } else {
            return resolve(result.flat())
          }
        }).catch(err => {
          return reject(err)
        })
      }, timeout)
    })
  },
  getAllActivityTypes: (apikey) => {
    return new Promise((resolve, reject) => {
      return MoskitWrapper.requestToMoskit(
        apikey,
        'https://api.moskitcrm.com/v2/activityTypes?quantity=50'
      ).then(activityTypes => {
        return resolve(activityTypes)
      }).catch(err => {
        return reject(err)
      })
    })
  },
  getAllUsers: (apikey) => {
    return new Promise((resolve, reject) => {
      return MoskitWrapper.requestToMoskit(
        apikey,
        'https://api.moskitcrm.com/v2/users?sort=name&quantity=50'
      ).then(users => {
        return resolve(users.filter(user => user.active === true))
      }).catch(err => {
        return reject(err)
      })
    })
  }
}

export default MoskitWrapper



// WEBPACK FOOTER //
// ./src/services/moskit-wrapper.js